module.exports = __webpack_public_path__ + "static/media/app-store-badge.67c5fbfe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/static/images/app-store-badge.svg
// module id = 86
// module chunks = 1